import { Controller } from "@hotwired/stimulus";
import Quill from "quill";

// Connects to data-controller="quill"
export default class extends Controller {
  static targets = ["editor", "input"];

  connect() {
    this.quill = new Quill(this.editorTarget, {
      theme: "snow",
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "image", "video"],
          ["clean"],
        ],
      },
    });

    // Set initial content if the hidden input has a value
    if (this.inputTarget.value) {
      this.quill.clipboard.dangerouslyPasteHTML(this.inputTarget.value);
    }

    // Update hidden input when Quill content changes
    this.quill.on("text-change", () => {
      this.inputTarget.value = this.quill.root.innerHTML;
    });
  }
}
